import { render } from "./recruiterBridge.vue?vue&type=template&id=4d5795ad"
import script from "./recruiterBridge.vue?vue&type=script&lang=js"
export * from "./recruiterBridge.vue?vue&type=script&lang=js"

import "./recruiterBridge.vue?vue&type=style&index=0&id=4d5795ad&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__